import { render } from "./SectionInstagram.vue?vue&type=template&id=6264a322"
import script from "./SectionInstagram.vue?vue&type=script&lang=js"
export * from "./SectionInstagram.vue?vue&type=script&lang=js"
script.render = render

export default script